import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { FeedbackMessage } from "@gemini/ui";
import { BusIcon, CarIcon, BikingIcon, WalkingIcon } from "@gemini/icons";
import { useI18n } from "@/shared/hooks";
import { useLocation } from "@/location/hooks/useLocation";
import { TRANSPORTATION_MODES } from "../../../constants";
const transportationIcons = {
    car: CarIcon,
    transit: BusIcon,
    walk: WalkingIcon,
    bike: BikingIcon,
};
export const travelTimeTestId = "cdp-location-map-travel-time";
export const TravelTimeIndicators = ({ travelTimes = [], isDistanceTooFar, }) => {
    const { t } = useI18n();
    const { geometry } = useLocation() || {};
    const isPolygon = (geometry === null || geometry === void 0 ? void 0 : geometry.type) !== "Point";
    const travelTimeMap = Object.fromEntries(travelTimes.map(({ travel_mode, travel_time }) => [
        travel_mode,
        travel_time,
    ]));
    const timeInMinSeparator = isPolygon ? "~ " : "";
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.16", children: [_jsx(Box, { marginTop: "spacing.32", display: "flex", justifyContent: "space-between", children: TRANSPORTATION_MODES.map((mode) => {
                    const Icon = transportationIcons[mode];
                    const travel_time = travelTimeMap[mode];
                    const timeInMin = travel_time ? Math.floor(travel_time / 60) : null;
                    return (_jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", testId: `${travelTimeTestId}.${mode}`, children: [_jsx(Icon, {}), _jsx(Box, { as: "span", typography: "typography.body.14.regular", children: timeInMin !== null
                                    ? `${timeInMinSeparator}${timeInMin} min`
                                    : "-" })] }, mode));
                }) }), isPolygon && travelTimes.length !== 0 && (_jsx(FeedbackMessage, { variant: "info", children: t("location.map.modal.travel_times.average_indication") })), isDistanceTooFar && (_jsx(FeedbackMessage, { variant: "warning", children: t("location.map.modal.travel_times.distance_too_far_indication") }))] }));
};
